import { render, staticRenderFns } from "./favorite.vue?vue&type=template&id=acc1f4ea&scoped=true&"
import script from "./favorite.vue?vue&type=script&lang=js&"
export * from "./favorite.vue?vue&type=script&lang=js&"
import style0 from "./favorite.vue?vue&type=style&index=0&id=acc1f4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc1f4ea",
  null
  
)

export default component.exports